<template>
  <div class="row">
    <div class="col-4">
      <div class="left-banner">
        <img src="@/assets/images/logo_white.png"
             alt="">
      </div>

    </div>

    <div class="col-8">

      <div class="right-form">

        <h1 class="mb-5">Admin Panel</h1>
        <p class="text-center lead mb-5">
          ลงชื่อเข้าใช้งานระบบร้านค้ารับพัสดุของคุณ
        </p>

        <Card>
          <div slot="body">
            <ValidationObserver v-slot="{ invalid }">
              <form @submit.prevent="handleLogin"
                    class="p-2">
                <TextBox type="text"
                         id="email-textbox"
                         :label="$t('general.email')"
                         :placeholder="$t('general.email')"
                         rules="required"
                         v-model="loginForm.email" />
                <TextBox type="password"
                         id="password-textbox"
                         :label="$t('general.password')"
                         :placeholder="$t('general.password')"
                         rules="required"
                         v-model="loginForm.password" />

                <div class="auth-box__cta-wrapper d-flex justify-content-between">
                  <Button id="submit-login-form-button"
                          :disabled="invalid"
                          class="btn-block"
                          variant="danger"
                          size="md"
                          :loading="loginLoading">{{ $t("login.sign_in") }}</Button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/core/Button";
import TextBox from "@/components/core/TextBox";
import Card from "@/components/core/Card";

export default {
  name: "Home",
  components: {
    TextBox,
    Button,
    Card
  },

  data() {
    return {
      loginLoading: false,
      loginForm: {
        email: null,
        password: null,
      },
    };
  },

  methods: {
    async handleLogin() {
      this.loginLoading = true;
      const { status } = await this.$store.dispatch("user/login", {
        data: {
          email: this.loginForm.email,
          password: this.loginForm.password,
        }
      })

      if (status) {
        this.$router.push({ name: "Users" });
      }

      this.loginLoading = false;
    },
  }
};
</script>


<style lang="scss"
       scoped>

      .left-banner {
        background-color: red;
        height: 100vh;
        position: relative;

        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 80%;
        }
      }

      .right-form {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    </style>